import { AxiosInstance } from "axios"
import {
    OrderForCalendar,
    ReportDetails,
} from "../merchant/merchant/production/ordersForCalendar/ordersForCalendarTypes"

export enum UserDetails {
    USER_CALENDAR_EVENTS = "user-calendar-events",
    USER_AVAILABLE_ROOMS = "user-available-rooms",
}

export type FetchUserCalendarEventsResponse = Readonly<{
    reportDetails: ReportDetails | any
    orders: OrderForCalendar[]
}>

type FetchUserCalendarEventsParams = Readonly<{
    userId: number
    startDate: string
    endDate: string
}>

export async function fetchUserCalendarEvents(
    { userId, endDate, startDate }: FetchUserCalendarEventsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchUserCalendarEventsResponse> {
    const url = `/users/${userId}/events`

    const response = await axios.get(url, {
        params: {
            startDate,
            endDate,
        },
        signal,
    })

    return response.data
}

type FetchAvailableRoomsParams = Readonly<{
    locationId: number
    startDateTime: string | null
    endDateTime: string | null
}>

export type FetchAvailableRoomsResponse = Readonly<{
    availableRooms: { count: number }
}>

export async function fetchAvailableRooms(
    { locationId, startDateTime, endDateTime }: FetchAvailableRoomsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchAvailableRoomsResponse> {
    const url = `/locations/${locationId}/availableRooms`

    const response = await axios.get(url, {
        params: {
            startDateTime,
            endDateTime,
        },
        signal,
    })

    return response.data
}
